import { defineComponent as _defineComponent } from 'vue'
import useSegment from '@/composables/useSegment'
  import { UserModule } from '@/store/modules/user'
  import eventBus from '@/main'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'UserReferralCode',
  props: {
    referralCode: {
      type: String,
      required: true,
    },
  },
  setup(__props) {

const props = __props;

  

  const { referralCandyInviteCodeModalShown } = useSegment()
  const openReferralCodeModal = () => {
    referralCandyInviteCodeModalShown(UserModule.email)
    eventBus.$emit('show-modal', {
      modalContentComponent: 'ReferralCodeModal',
      cssClass: 'referral-code-modal',
      modalProps: {
        referralCode: props.referralCode,
      },
      modalCloseCallback: (callback: () => void) => {
        if (typeof callback === 'function') callback()
      },
    })
  }

return { __sfc: true,props, referralCandyInviteCodeModalShown, openReferralCodeModal, useSegment, UserModule, eventBus }
}

})